import { useState, useEffect } from 'react';
import Dashboard from './Dashboard';
import HeaderOuter from '../Nav Bar/HeaderOuter';
import Offers from '../Offers/Offer';
import Toggle from './Toggle';
import { setActivity, getdata, useProfile } from '../../Global/Index';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material';
import PropTypes from 'prop-types'; // Import PropTypes
import Banner from '../Slider/Banner';
import { toast, ToastContainer } from 'react-toastify';
import Cookies from 'js-cookie';

import {
  MdFlashOn,
  MdLocationOn,
  MdCalculate,
  MdDescription,
  MdReportProblem,
  MdHelpOutline,
  MdContactSupport,
  MdCardGiftcard,
} from 'react-icons/md';

import { FaWhatsapp } from 'react-icons/fa';




const DashboardRightComponent = ({ mobile_number }) => {
  const theme = useTheme();

  return (
    <div className='dashboard-right-container' style={{ color: theme.palette.primary.main }} >
      <div className='dashboard-content'>
        {/* Quick Actions Header */}
        <div className='section-header'>
          <MdFlashOn className="section-header-icon" />
          <span>Quick Actions</span>
        </div>

        {/* WhatsApp Toggle */}
        <div className='toggle-item' style={{ backgroundColor: theme.palette.background.alt, color: theme.palette.primary.main }}>
          <div className='toggle-content'>
            <FaWhatsapp className="menu-icon-dashboard" />
            <span className='toggle-text'>
              Get Regular Updates in WhatsApp
            </span>
          </div>
          <Toggle mobile_number={mobile_number} />
        </div>

        {/* Menu Items */}
        <div className='menu-item'>
          <MdLocationOn className="menu-icon-dashboard" />
          <a
            className='menu-link'
            style={{ color: theme.palette.primary[100] }}
            href={'https://branch.indiashelter.in/'}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => setActivity('Branch Locator Page')}
          >
            Branch Locator
          </a>
        </div>

        <div className='menu-item'>
          <MdCalculate className="menu-icon-dashboard" />
          <Link
            className='menu-link'
            style={{ color: theme.palette.primary[100] }}
            to={'/intCal'}
          >
            EMI Calculator
          </Link>
        </div>

        <div className='menu-item'>
          <MdDescription className="menu-icon-dashboard" />
          <Link
            className='menu-link'
            style={{ color: theme.palette.primary[100] }}
            to={'/TermsAndConditions'}
          >
            Terms and Conditions
          </Link>
        </div>

        <div className='menu-item'>
          <MdReportProblem className="menu-icon-dashboard" />
          <Link
            className='menu-link'
            style={{ color: theme.palette.primary[100] }}
            to={`/raiseComplaint`}
            target="_blank"
          >
            Raise Complaint
          </Link>
        </div>

        <div className='menu-item'>
          <MdHelpOutline className="menu-icon-dashboard" />
          <Link
            className='menu-link'
            style={{ color: theme.palette.primary[100] }}
            to={'/Faq'}
          >
            FAQs
          </Link>
        </div>

        <div className='menu-item menu-item-last'>
          <MdContactSupport className="menu-icon-dashboard" />
          <a
            className='menu-link'
            style={{ color: theme.palette.primary[100] }}
            href={'https://www.indiashelter.in/contact-us'}
            target="_blank"
            rel="noopener noreferrer"
          >
            Contact Us
          </a>
        </div>
      </div>

      {/* Special Offers Section */}
      <div className='offers-section'>
        <h3 className='offers-header'>
          <MdCardGiftcard className="section-header-icon" />
          Special Offers for you
        </h3>
        <div className='offer-detail'>
          <Offers mobile_number={mobile_number} />
        </div>
      </div>
    </div>
  );
};

export default function DashboardPage() {
  const [tokendata, setTokendata] = useState(null);
  const [isbannervisible, setIsbannervisible] = useState(null);
  const accessToken = Cookies.get('access_token');
  const token = Cookies.get('token');

  const theme = localStorage.getItem('themeMode');

  if (theme === 'dark') {
    document.body.classList.add('dark-theme');
  } else {
    document.body.classList.remove('dark-theme');
  }

  useEffect(() => {
    const getdatafunction = async () => {
      const data = await getdata();
      if (data.response.status == '200') {
        setIsbannervisible(data.response.data.isbannervisible)
        setTokendata(data.response.data)
      }
    }
    getdatafunction()
    setActivity('Dashboard Page');
  }, [])


  const { data, error: profileerror } = useProfile();

  if (profileerror) {
    if (profileerror.response.status == "500") {
      console.warn('something went wrong. Please try again later!')
    } else if (profileerror.response.status == '419') {
      window.location.href = "/Session-Expired"
    } else if (profileerror.response.status == '401') {
      window.location.href = "/"
    }
  }

  const ProfileData = data?.response.data


  if (!accessToken || !token) {
    window.location.href = '/'
  } else {
    return (
      <div className='dashboardpage'>
        <ToastContainer />
        {
          isbannervisible && <Banner />
        }
        <HeaderOuter />
        {ProfileData && <p className="profilename"> <b>Welcome</b>  {ProfileData?.name}</p>}
        <div className='dashboardcomponents'>
          <div className="dashboardpageleftside">
            <Dashboard />
          </div>
          <div className="dashboardpagerightside">
            <DashboardRightComponent mobile_number={tokendata?.MobileNumber} setIsbannervisible={setIsbannervisible} />
          </div>
        </div>
      </div>
    );
  }



}
DashboardRightComponent.propTypes = {
  mobile_number: PropTypes.string,
};